import React, { useState } from 'react';
import { features } from 'configs';
import { useTabAreaContext } from 'pages/SharePage/Context/TabAreaContext';
import { PropTypes } from 'prop-types';
import { useUserContext } from 'store';
import { GrantedConsentsTab } from '../GrantedConsentsTab';
import { ReceivedConsentsTab } from '../ReceivedConsentsTab';

import './TabArea.css';

export function TabArea({ searchFilter }) {
  const [individuoTabIsOpen, setIndividuoTabIsOpen] = useState(true);
  const { granted, received } = useTabAreaContext();

  const [user] = useUserContext();

  return (
    <div className="tabArea">
      <div className="sharePage-tabs">
        <button
          className={individuoTabIsOpen && 'sharePage-openTab'}
          onClick={() => setIndividuoTabIsOpen(true)}
        >
          Indivíduo
        </button>
        {features.granted && (
          <button
            className={
              !individuoTabIsOpen && 'sharePage-openTab instituitionButton'
            }
            onClick={() => setIndividuoTabIsOpen(false)}
          >
            Unidade de saúde
          </button>
        )}
      </div>

      {received && (
        <>
          {individuoTabIsOpen && (
            <ReceivedConsentsTab data={received} searchFilter={searchFilter} />
          )}
        </>
      )}

      {features.granted && granted && (
        <>
          {individuoTabIsOpen ? (
            <GrantedConsentsTab
              data={granted}
              searchFilter={searchFilter}
              type={0}
              subject={user.cpf}
            />
          ) : (
            <GrantedConsentsTab
              data={granted}
              searchFilter={searchFilter}
              type={1}
              subject={user.cpf}
            />
          )}
        </>
      )}
    </div>
  );
}

TabArea.propTypes = {
  searchFilter: PropTypes.element.isRequired,
};
